/** @format */
import React from 'react';
import Card from '../../components/ui/card';
import SubscriptionCardIcon from '../../components/ui/icons/SubscriptionCardIcon';

// Constants for subscription thresholds
const SUBSCRIPTION_THRESHOLDS = {
	HIGH_VOLUME: 100,
	MAX_DISPLAY_COUNT: 99,
	ACTIVE_PERCENTAGE: 0.6,
};

const TotalSubscriptionsCard = ({ 
	totalSubscriptions = 0, 
	isLoading = false 
}) => {
	if (isLoading) {
		return (
			<Card className="overflow-hidden animate-pulse">
				<div className="p-4 sm:p-6">
					<div className="flex justify-between items-start mb-4">
						<div>
							<div className="h-4 bg-gray-100 rounded w-40 mb-2"></div>
							<div className="h-12 bg-gray-50 rounded w-24"></div>
						</div>
						<div className="rounded-full p-3 sm:p-4 bg-gray-100">
							<div className="h-6 w-6 sm:h-7 sm:w-7 bg-gray-200 rounded"></div>
						</div>
					</div>
					<div className="h-4 bg-gray-100 rounded w-24 mb-4"></div>
					<div className="pt-4 border-t border-gray-100">
						<div className="h-3 bg-gray-50 rounded w-32"></div>
					</div>
				</div>
			</Card>
		);
	}

	return (
		<Card className="overflow-hidden bg-white border border-gray-100 hover:shadow-lg transition-shadow duration-200">
			<div className="p-4 sm:p-6">
				<div className="flex justify-between items-start mb-4">
					<div>
						<h3 className="text-sm font-montserrat-medium text-gray-700 uppercase tracking-wide">
							Total Subscriptions
						</h3>
						<p className="text-2xl sm:text-3xl font-glacial text-gray-900 mt-2">
							{(totalSubscriptions || 0).toLocaleString()}
						</p>
					</div>
					<div className="rounded-full p-3 sm:p-4 bg-gray-100">
						<SubscriptionCardIcon
							className="h-6 w-6 sm:h-7 sm:w-7 text-clientBlack"
							count={Math.min(totalSubscriptions, SUBSCRIPTION_THRESHOLDS.MAX_DISPLAY_COUNT)}
							showPinkAccent={totalSubscriptions > SUBSCRIPTION_THRESHOLDS.HIGH_VOLUME}
							isActive={totalSubscriptions > 0}
						/>
					</div>
				</div>
				
				{/* Micro-trend indicator */}
				<div className="flex items-center space-x-2 mb-4">
					<span className="text-sm font-montserrat-regular text-gray-600">
						<span className="font-montserrat-medium text-green-600">+8%</span>
						{' '}this month
					</span>
				</div>
				
				{/* Contextual insight */}
				<div className="pt-4 border-t border-gray-100">
					<span className="text-xs font-montserrat-regular text-gray-500">
						{Math.max(1, Math.floor(totalSubscriptions * SUBSCRIPTION_THRESHOLDS.ACTIVE_PERCENTAGE))} active subscriptions
					</span>
				</div>
			</div>
		</Card>
	);
};

export default TotalSubscriptionsCard;